import "./assets/main.css";

import { createApp } from "vue";
import { createPinia } from "pinia";
import "element-plus/dist/index.css";
import "@shared/tailwind.css";
import "@shared/styles.css";

import App from "./App.vue";
import router from "./router";
import messagesShared, { mergeMessages } from "@shared/i18n";
import localMessages from "./i18n";
import ElementPlus from "element-plus";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import VueClickAway from "vue3-click-away";
import {
  AuthErrorInterceptor,
  AuthInterceptor,
} from "@shared/services/interceptor";
import { Vue3Mq } from "vue3-mq";
import VueObserveVisibility from "vue-observe-visibility";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import * as Sentry from "@sentry/vue";
import { smxElements } from "@shared/components/elements/smxElements";
import { useIcons } from "@shared/util/icons";
import { sentryInit } from "@shared/util/sentry";
import { initClients } from "@shared/client";
import { initLanguages } from "@shared/util/languages";

initClients({
  requestInterceptors: [
    {
      onFulfilled: AuthInterceptor(
        {
          postLogout: () => {},
        },
        router,
      ),
      onRejected: (e) => {
        return e;
      },
    },
  ],
  responseInterceptors: [
    {
      onFulfilled: (response) => {
        return response;
      },
      onRejected: AuthErrorInterceptor({
        postLogout: () => {},
      }),
    },
  ],
});

const app = createApp(App);

export const i18n = initLanguages({
  languages: new Set(["de", "en", "es"]),
  defaultLanguage: "de",
  messages: mergeMessages(messagesShared, localMessages),
});

const isDevEnvironment = process.env.NODE_ENV == "development";

if (!isDevEnvironment) {
  Sentry.init(sentryInit(app, router));
} else {
  console.log("dev environment, sentry disabled");
}

// TODO: check which icons are still in use and remove successively
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}

// Font awesome icons
useIcons();

for (const [key, component] of Object.entries(smxElements)) {
  app.component(key, component);
}
app.component("FontAwesomeIcon", FontAwesomeIcon);
app.use(Vue3Mq, {
  preset: "tailwind",
});
app.use(createPinia());
app.use(router);
app.use(ElementPlus);
app.use(i18n);
app.use(VueClickAway);
app.use(VueObserveVisibility);
app.mount("#app");
